import { useState } from "react";
import { faqs } from "@/mocks/siteContent";
import SectionHeader from "./SectionHeader";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };

  return (
    <section id="faq" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <SectionHeader
          eyebrow="常见问题"
          title="你想知道的，都在这里"
          desc="关于更新频率、题材分类、完结筛选与评分机制，我们整理了读者最常关心的问题并一一解答。"
        />

        <div className="space-y-3">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={f.question}
                className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                  open ? "border-primary-200" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{f.question}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-add-line transition-transform ${open ? "rotate-45" : ""}`} aria-hidden="true" />
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-100 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      </div>
    </section>
  );
}